<template>
  <div class="form-field" :class="props.class">
    <label :for="uniqueId" class="form-label">{{props.label}}</label>
    <select v-bind="$attrs" :id="uniqueId" v-model="model" class="form-select" :disabled="props.optionsLoading" :class="{'form-select--loading':props.optionsLoading}">
      <option disabled :value="''">{{props.optionsLoading ? props.placeholderLoading : props.placeholder}}</option>
      <option v-for="item in props.options" :value="item.id">{{ item.text }}</option>
    </select>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import useUniqueId from '../../../directives/uniqueId';

defineOptions({
  inheritAttrs: false
});

const {uniqueId} = useUniqueId();

const props = defineProps({
  class: {
    type: String,
  },
  label: {
    type: String,
    default: 'Informe o label'
  },
  placeholder: {
    type: String,
    default: ''
  },
  placeholderLoading: {
    type: String,
    default: 'Carregando...'
  },
  options: {
    type: [Array],
    required: true,
  },
  optionsLoading: {
    type: Boolean,
    default: false
  }
});

const model = defineModel({default:''});

watch(() => props.options, (n, o) => {
  if(n.length == 0) {
    model.value = '';
  }
});


</script>
